export class Tag {
    Title: string;
    ID: string;
}